module.exports = __webpack_public_path__ + "static/media/section-category-header.713182c5.png";